import { Component, Input } from '@angular/core';
import { AndromedaButtonTypes } from '../../models/andromeda-button-types';
import { AndromedaPalettes } from '../../models/andromeda-palettes';
import { AndromedaCustomTooltipDirective } from '../andromeda-custom-tooltip/andromeda-custom-tooltip.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-andromeda-button',
  templateUrl: './andromeda-button.component.html',
  styleUrls: ['./andromeda-button.component.scss'],
  imports: [AndromedaCustomTooltipDirective, NgClass],
})
export class AndromedaButtonComponent {
  @Input() type = AndromedaButtonTypes.Flat;
  @Input() palette = AndromedaPalettes.Basic;
  @Input() buttonClass: string;
  @Input() tooltipValue = null;
  @Input() disabled = false;

  andromedaButtonTypes = AndromedaButtonTypes;
  andromedaPalettes = AndromedaPalettes;

  constructor() {
    // This is intentional
  }

  getClassForType(): string {
    return 'andromeda-' + this.type + '-button';
  }

  getClassForPalette(): AndromedaPalettes {
    return this.palette;
  }

  getClasses(): string {
    return (
      this.getClassForType() +
      ' ' +
      this.getClassForPalette() +
      ' ' +
      (this.buttonClass ? this.buttonClass : '')
    );
  }
}
